import React from 'react'
import PropTypes from 'prop-types'
import UsersStaticsDetailTableThead from "./UsersStaticsDetailTableThead"
import UsersStaticsDetailTableBody from "./UsersStaticsDetailTableBody"
import {Spin} from "antd"

function UsersStaticsDetailTable(props) {
    const {statics, loading, error} = props

    return (
        <div className='UsersStaticsDetailTable'>
            <Spin spinning={loading} tip="Đang lấy thông tin...">
                <table className="table table-bordered">
                    <UsersStaticsDetailTableThead/>
                    <UsersStaticsDetailTableBody statics={statics} error={error}/>
                </table>
            </Spin>
        </div>
    )
}

UsersStaticsDetailTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    statics: PropTypes.array
}

export default UsersStaticsDetailTable
